import type { useSingleton } from "@tippyjs/react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { LogoIcon } from "@/icons";
import styles from "@/interface/HeaderBar/LeftBar/LeftBar.module.css";
import { Tooltip } from "@/interface/ui/Tooltip";

export const LogoLink = ({
    singletoneTarget,
}: {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
}) => {
    const { t } = useTranslation();
    const shouldNavigate = !canv.isGrantedAccess() || canv.isBoardModeEditMini();
    const link = shouldNavigate ? `${canv.host}/dashboard` : "#";

    const logoLink = (
        <a href={link} rel="noopener" className={styles.logoLink}>
            <LogoIcon />
        </a>
    );

    if (shouldNavigate) {
        return (
            <Tooltip singleton={singletoneTarget} content={t("header.home")}>
                {logoLink}
            </Tooltip>
        );
    }

    return logoLink;
};
